import styled from "styled-components";

export const BlueCircle = styled.div`
  width: 16px;
  height: 16px;
  background-color: blue;
  border: 2px solid white;
  border-radius: 50%;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.3); // Optional: adds a subtle shadow
`;
